const enum MobileClaimFormStatus {
  ready = 'ready',
  success = 'success',
  error = 'error',
}

export default MobileClaimFormStatus;
